import { object, string } from 'yup'
import { t } from 'ttag'

import { TEMPLATE_NAME_FIELD } from './model'

export const TEMPLATE_NAME_LIMIT = 100

export const getSchema = () =>
  object().shape({
    [TEMPLATE_NAME_FIELD]: string()
      .max(TEMPLATE_NAME_LIMIT, t`Template name cannot exceed 100 characters.`)
      .required(t`This field cannot be empty.`),
  })
